<template>
    <div class="clearfix">
        <kt-row>
        <router-link  class="kt-nav__link m-2 btn btn-outline-primary"
                      :to="'pos/sent_documents'">
            {{ $t('pos.sent_documents') }}
        </router-link>
        </kt-row>
        <kt-row>
        <add-file-form :customer_data="customer_data" :submit="addFile" :form_data="form_data"></add-file-form>
        </kt-row>
    </div>
</template>

<script>

import addFileForm from './add-file-form'
import $ from "jquery";
import {KTApp} from '@/plugins/core/app'
import {posService} from '@/common/api.service'


export default {
    data() {
        return {
            form_data: {},
        }
    },
    props: {
        customer_data: [],
    },
    components: {
        'add-file-form': addFileForm
    },
    methods: {
        addFile() {
            let form = $('#add_file_form')
            let btn = $('#submit_btn')

            KTApp.progress(btn)

            posService.addFile(this.form_data).then(response => {
                this.$router.push('/pos')
            })
                    .catch(({response}) => {
                        if (response.data) {
                            form.validate().showErrors(response.data.data)
                        }
                        this.showMsg(form, 'danger', response.data.message)
                    })
                    .finally(() => {
                        KTApp.unprogress(btn)
                    })
        }
    }
}
</script>

<style>

</style>